import Accordion from "@intility/bifrost-react/Accordion";
import type { TreeNode } from "./MiniCanvas";
import MiniCanvas from "./MiniCanvas";

const ARCHETYPES: { title: string; description: string; tree: TreeNode }[] = [
  {
    title: "Flat",
    description:
      "A single layer of resources below the platform. Useful for platforms that don't need complex layers of authorization, where it's fine to grant access to entire functional areas for users.",
    tree: {
      label: "Platform",
      kind: "platform",
      children: [
        { label: "dashboards", kind: "resource", typeKind: "static" },
        { label: "alerts", kind: "resource", typeKind: "static" },
        { label: "rules", kind: "resource", typeKind: "static" },
      ],
    },
  },
  {
    title: "Collection and per-instance authorization",
    description:
      "A collection groups individual instances. With both a collection and instance node, you can grant access to all items at once or restrict it to specific ones.",
    tree: {
      label: "Platform",
      kind: "platform",
      children: [
        {
          label: "servers",
          kind: "resource",
          typeKind: "static",
          children: [
            { label: "server", kind: "resource", typeKind: "dynamic" },
          ],
        },
        {
          label: "databases",
          kind: "resource",
          typeKind: "static",
          children: [
            { label: "database", kind: "resource", typeKind: "dynamic" },
          ],
        },
      ],
    },
  },
  {
    title: "Deeply nested",
    description:
      "You can keep nesting collections and instances as deep as you need, but each layer adds complexity to the authorization model. Aim for the shallowest structure that covers your needs.",
    tree: {
      label: "Platform",
      kind: "platform",
      children: [
        {
          label: "regions",
          kind: "resource",
          typeKind: "static",
          children: [
            {
              label: "region",
              kind: "resource",
              typeKind: "dynamic",
              children: [
                {
                  label: "subscriptions",
                  kind: "resource",
                  typeKind: "static",
                  children: [
                    {
                      label: "subscription",
                      kind: "resource",
                      typeKind: "dynamic",
                      children: [
                        {
                          label: "users",
                          kind: "resource",
                          typeKind: "static",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  },
];

export default function ArchetypeShowcase() {
  return (
    <Accordion variant="styled">
      {ARCHETYPES.map((arch) => (
        <Accordion.Item key={arch.title} title={arch.title}>
          <p
            className="bf-p"
            style={{ margin: "0 0 12px", color: "var(--bfc-base-c-2)" }}
          >
            {arch.description}
          </p>
          <MiniCanvas root={arch.tree} />
        </Accordion.Item>
      ))}
    </Accordion>
  );
}
